import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Form,
  Grid,
  Icon,
  Label,
} from 'semantic-ui-react';
import { required, stringLength } from '@mhub/web-validations';
import AppForm from '../../../components/AppForm';
import FormulaDropdownInput from '../../../components/Sortable/SortablePackagePricing/FormulaDropdownInput';
import { PROJECT_PACKAGE_PRICING_ITEM_DEFAULT } from '../../../structs/package_pricing';

export default class PackagePricingItemEdit extends Component {
  static propTypes = {
    data: PropTypes.shape(),
    onChange: PropTypes.func,
    onDelete: PropTypes.func,
    refForm: PropTypes.func,
    refValidation: PropTypes.func,
  }
  static defaultProps = {
    data: Object.assign({}, PROJECT_PACKAGE_PRICING_ITEM_DEFAULT),
  }
  handleDelete = (e) => {
    e.preventDefault();
    const { data } = this.props;
    if (this.props.onDelete) this.props.onDelete(data);
  }
  handleSave = (e) => {
    if (e) e.preventDefault();
    const { data } = this.props;
    if (this.props.onChange) this.props.onChange(data);
  }
  handleInputChange = (e, d) => {
    const { data } = this.props;
    data[d.name] = d.value;
    if (this.props.onChange) this.props.onChange(data);
  }
  handleCheckboxChange = (e, d) => {
    const { data } = this.props;
    data[d.name] = !data[d.name];
    if (this.props.onChange) this.props.onChange(data);
  }
  handleScheduleConfirm = (value) => {
    const { data } = this.props;
    data.scheduleStartAt = value.scheduleStartAt;
    data.scheduleEndAt = value.scheduleEndAt;
    if (this.props.onChange) this.props.onChange(data);
  }
  handleBUAccessChange = (value) => {
    const { data } = this.props;
    data.businessUnitAccesses = value;
    if (this.props.onChange) this.props.onChange(data);
  }
  render() {
    const { data } = this.props;
    return (
      <div className="sortablehoc_item">
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <AppForm
                as="div"
                onSubmit={this.handleSave}
                ref={this.props.refForm}
              >
                <Grid>
                  {/* Name & Description */}
                  <Grid.Row className="row_name_desc">
                    <Grid.Column mobile={16} tablet={6} computer={6}>
                      <AppForm.Input
                        label="Formula Name"
                        name="name"
                        onChange={this.handleInputChange}
                        placeholder="Formula Name"
                        ref={this.props.refValidation}
                        type="text"
                        validateLabel="Formula Name"
                        validation={[required, {
                          validate: stringLength,
                          option: {
                            max: 128,
                          },
                        }]}
                        value={data.name}
                      />
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={10} computer={10}>
                      <Label className="row_label" content="Formula Description" />
                      <Form.TextArea
                        name="description"
                        onChange={this.handleInputChange}
                        placeholder="Formula Description"
                        type="text"
                        rows={1}
                        value={data.description}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  {/* Checkboxes & Delete */}
                  <Grid.Row verticalAlign="middle" className="row_enable_formula_delete">
                    <Grid.Column mobile={16} tablet={5} computer={3}>
                      <Form.Checkbox
                        checked={data.isEnabled}
                        label="Enable Formula"
                        name="isEnabled"
                        onChange={this.handleCheckboxChange}
                        ref={this.props.refValidation}
                        toggle
                      />
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={9} computer={12}>
                      <FormulaDropdownInput
                        {...this.props}
                        data={data}
                        onChange={this.handleInputChange}
                      />
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={2} computer={1} className="column_delete">
                      <Button
                        size="small"
                        basic
                        compact
                        icon
                        onClick={this.handleDelete}
                      >
                        <Icon name="trash" color="red" />
                      </Button>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </AppForm>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sortable/SortablePackagePricing/PackagePricingItemEdit.jsx